module.exports = __webpack_public_path__ + "img/Taekwondo.7f09baf7.png";